import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import * as my from './MyForm'

export const GroupBox = ({
	className = '',
	classNameContent = '',
	inline = false,
	inlineExtended = false,
	label = '',
	labelBold = false,
	flex = {},
	showBorder = false,
	children,
	...rest
}) => {
	return (
		<my.Elemet data-inline={!!inline} data-inline-extended={inlineExtended} className={className}>
			{!!label && (
				<my.Label data-inline={!!inline}
									data-inline-extended={inlineExtended}
									data-bold={labelBold}>
					{label}
				</my.Label>
			)}
			<my.GroupBox className={`flex flex-${flex?.direction || 'row'} items-${flex?.items || 'stretch'} 
					justify-${flex?.justify || 'start'} space-${flex?.space || 'x-2'}
					${showBorder && 'border-l border-grey-200 pl-4'} 
					${classNameContent}`}
			>
				{children}
			</my.GroupBox>
		</my.Elemet>
	)
}
GroupBox.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
}
